export const Permissions = {
	// letters
	"canCreateLetter": [ "admin", "expert", "editor" ],

	// templates
	"canCreateTemplate": [ "admin", "expert", "editor" ],

	// dictionary
	"canEditDictionary": [ "admin", "expert" ],
	"canManageWholeDictionary": [ "admin" ],

	// users
	"canOpenUserManagement": [ "admin" ],
	"canManageUsers": [ "admin" ],

	// departments
	"canOpenDepartmentManagement": [ "admin", "expert", "editor" ],
	"canAddDepartments": [ "admin" ],
	"canDeleteDepartments": [ "admin" ],

	// template management
	"canOpenTemplateManagement": [ "admin" ],

	// reports
	"canOpenReportGeneration": [ "admin" ],

	// simple text advices
	"canAskQuestions": [ "admin", "expert", "editor" ],
	"canManageQuestions": [ "admin", "expert" ],
};

export const CheckPermission = (permission, role) => {
	return Permissions[permission].includes(role);
};

export const CanHandleDepartments = (role, mode) => {
	return role === 'admin' || mode !== 'standalone';
};